exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontello-codes__icon--arrow-right__1ynFz:before{content:\"\\E800\"}.fontello-codes__icon--volume-mute__2SXBQ:before{content:\"\\E801\"}.fontello-codes__icon--buy-rent__3gOep:before{content:\"\\E802\"}.fontello-codes__icon--replay-button__3uh2f:before{content:\"\\E803\"}.fontello-codes__icon--quality-selector__FoKJd:before{content:\"\\E804\"}.fontello-codes__icon--replay-player___xZFq:before{content:\"\\E805\"}.fontello-codes__icon--buy__2p3ra:before{content:\"\\E806\"}.fontello-codes__icon--clear-enter__2WYQY:before{content:\"\\E807\"}.fontello-codes__icon--search-enter__1h2Wa:before{content:\"\\E808\"}.fontello-codes__icon--search__36uSS:before{content:\"\\E809\"}.fontello-codes__icon--download__2_kqz:before{content:\"\\E80A\"}.fontello-codes__icon--exit-fullscreen-hover__hH0uT:before{content:\"\\E80B\"}.fontello-codes__icon--share__2HdoI:before{content:\"\\E80C\"}.fontello-codes__icon--exit-fullscreen__21HIN:before{content:\"\\E80D\"}.fontello-codes__icon--triangle-down__215Ub:before{content:\"\\E80E\"}.fontello-codes__icon--tumblr__3kpbj:before{content:\"\\E80F\"}.fontello-codes__icon--exit__iXsnU:before{content:\"\\E810\"}.fontello-codes__icon--facebook__3wwTp:before{content:\"\\E811\"}.fontello-codes__icon--twitter__2hN7l:before{content:\"\\E812\"}.fontello-codes__icon--user__282GR:before{content:\"\\E813\"}.fontello-codes__icon--film__2XieP:before{content:\"\\E814\"}.fontello-codes__icon--fullscreen-hover__1W8UE:before{content:\"\\E815\"}.fontello-codes__icon--volume-50__3nQN0:before{content:\"\\E816\"}.fontello-codes__icon--volume-100__2v_Dx:before{content:\"\\E817\"}.fontello-codes__icon--fullscreen__2lVjD:before{content:\"\\E818\"}.fontello-codes__icon--gear__2InLN:before{content:\"\\E819\"}.fontello-codes__icon--hd__1GwNZ:before{content:\"\\E81A\"}.fontello-codes__icon--info__3Pv5X:before{content:\"\\E81B\"}.fontello-codes__icon--link__15dDv:before{content:\"\\E81C\"}.fontello-codes__icon--pause__iAM8T:before{content:\"\\E81D\"}.fontello-codes__icon--pinterest__U17Tx:before{content:\"\\E81E\"}.fontello-codes__icon--play__3zZ-b:before{content:\"\\E81F\"}.fontello-codes__icon--plus__MfCQL:before{content:\"\\E820\"}.fontello-codes__icon--overlay-play__1Dntt:before{content:\"\\E821\"}.fontello-codes__icon--timer__uBOUj:before{content:\"\\E822\"}.fontello-codes__icon--thin-x__23AO3:before{content:\"\\E8C3\"}", ""]);

// exports
exports.locals = {
	"icon--arrow-right": "fontello-codes__icon--arrow-right__1ynFz",
	"iconArrowRight": "fontello-codes__icon--arrow-right__1ynFz",
	"icon--volume-mute": "fontello-codes__icon--volume-mute__2SXBQ",
	"iconVolumeMute": "fontello-codes__icon--volume-mute__2SXBQ",
	"icon--buy-rent": "fontello-codes__icon--buy-rent__3gOep",
	"iconBuyRent": "fontello-codes__icon--buy-rent__3gOep",
	"icon--replay-button": "fontello-codes__icon--replay-button__3uh2f",
	"iconReplayButton": "fontello-codes__icon--replay-button__3uh2f",
	"icon--quality-selector": "fontello-codes__icon--quality-selector__FoKJd",
	"iconQualitySelector": "fontello-codes__icon--quality-selector__FoKJd",
	"icon--replay-player": "fontello-codes__icon--replay-player___xZFq",
	"iconReplayPlayer": "fontello-codes__icon--replay-player___xZFq",
	"icon--buy": "fontello-codes__icon--buy__2p3ra",
	"iconBuy": "fontello-codes__icon--buy__2p3ra",
	"icon--clear-enter": "fontello-codes__icon--clear-enter__2WYQY",
	"iconClearEnter": "fontello-codes__icon--clear-enter__2WYQY",
	"icon--search-enter": "fontello-codes__icon--search-enter__1h2Wa",
	"iconSearchEnter": "fontello-codes__icon--search-enter__1h2Wa",
	"icon--search": "fontello-codes__icon--search__36uSS",
	"iconSearch": "fontello-codes__icon--search__36uSS",
	"icon--download": "fontello-codes__icon--download__2_kqz",
	"iconDownload": "fontello-codes__icon--download__2_kqz",
	"icon--exit-fullscreen-hover": "fontello-codes__icon--exit-fullscreen-hover__hH0uT",
	"iconExitFullscreenHover": "fontello-codes__icon--exit-fullscreen-hover__hH0uT",
	"icon--share": "fontello-codes__icon--share__2HdoI",
	"iconShare": "fontello-codes__icon--share__2HdoI",
	"icon--exit-fullscreen": "fontello-codes__icon--exit-fullscreen__21HIN",
	"iconExitFullscreen": "fontello-codes__icon--exit-fullscreen__21HIN",
	"icon--triangle-down": "fontello-codes__icon--triangle-down__215Ub",
	"iconTriangleDown": "fontello-codes__icon--triangle-down__215Ub",
	"icon--tumblr": "fontello-codes__icon--tumblr__3kpbj",
	"iconTumblr": "fontello-codes__icon--tumblr__3kpbj",
	"icon--exit": "fontello-codes__icon--exit__iXsnU",
	"iconExit": "fontello-codes__icon--exit__iXsnU",
	"icon--facebook": "fontello-codes__icon--facebook__3wwTp",
	"iconFacebook": "fontello-codes__icon--facebook__3wwTp",
	"icon--twitter": "fontello-codes__icon--twitter__2hN7l",
	"iconTwitter": "fontello-codes__icon--twitter__2hN7l",
	"icon--user": "fontello-codes__icon--user__282GR",
	"iconUser": "fontello-codes__icon--user__282GR",
	"icon--film": "fontello-codes__icon--film__2XieP",
	"iconFilm": "fontello-codes__icon--film__2XieP",
	"icon--fullscreen-hover": "fontello-codes__icon--fullscreen-hover__1W8UE",
	"iconFullscreenHover": "fontello-codes__icon--fullscreen-hover__1W8UE",
	"icon--volume-50": "fontello-codes__icon--volume-50__3nQN0",
	"iconVolume50": "fontello-codes__icon--volume-50__3nQN0",
	"icon--volume-100": "fontello-codes__icon--volume-100__2v_Dx",
	"iconVolume100": "fontello-codes__icon--volume-100__2v_Dx",
	"icon--fullscreen": "fontello-codes__icon--fullscreen__2lVjD",
	"iconFullscreen": "fontello-codes__icon--fullscreen__2lVjD",
	"icon--gear": "fontello-codes__icon--gear__2InLN",
	"iconGear": "fontello-codes__icon--gear__2InLN",
	"icon--hd": "fontello-codes__icon--hd__1GwNZ",
	"iconHd": "fontello-codes__icon--hd__1GwNZ",
	"icon--info": "fontello-codes__icon--info__3Pv5X",
	"iconInfo": "fontello-codes__icon--info__3Pv5X",
	"icon--link": "fontello-codes__icon--link__15dDv",
	"iconLink": "fontello-codes__icon--link__15dDv",
	"icon--pause": "fontello-codes__icon--pause__iAM8T",
	"iconPause": "fontello-codes__icon--pause__iAM8T",
	"icon--pinterest": "fontello-codes__icon--pinterest__U17Tx",
	"iconPinterest": "fontello-codes__icon--pinterest__U17Tx",
	"icon--play": "fontello-codes__icon--play__3zZ-b",
	"iconPlay": "fontello-codes__icon--play__3zZ-b",
	"icon--plus": "fontello-codes__icon--plus__MfCQL",
	"iconPlus": "fontello-codes__icon--plus__MfCQL",
	"icon--overlay-play": "fontello-codes__icon--overlay-play__1Dntt",
	"iconOverlayPlay": "fontello-codes__icon--overlay-play__1Dntt",
	"icon--timer": "fontello-codes__icon--timer__uBOUj",
	"iconTimer": "fontello-codes__icon--timer__uBOUj",
	"icon--thin-x": "fontello-codes__icon--thin-x__23AO3",
	"iconThinX": "fontello-codes__icon--thin-x__23AO3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./src/widget/player-widget/fontello/css/fontello-codes.css
// module id = 1319
// module chunks = 0 1 2 3